import { useQuery } from 'react-query';
import { getAllActivity } from '../../apis/V2/userActivity';

export interface userProgressType {
	completionPercentage: number;
	createdAt: string;
	entity: string;
	entityType: 'Lecture' | 'Resource';
	updatedAt: string;
	user: string;
	__v: 0;
	_id: string;
}

export const useUserActivity = () => {
	return useQuery({
		queryKey: 'getAllActivity',
		queryFn: async () => (await getAllActivity()).data.userProgress as userProgressType[],
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
		enabled: true,
	});
};
